export enum BillingsTaxiDriverContributionPenaltyType {
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
}

export type BillingsTaxiDriverContributionPenaltyDummy = {
  type: null;
  comment: string;
  amount: number | null;
};

export type BillingsTaxiDriverContributionPenaltyReal = {
  type: BillingsTaxiDriverContributionPenaltyType;
  comment: string;
  amount: number | null;
};

type BillingsTaxiDriverContributionPenalty =
  | BillingsTaxiDriverContributionPenaltyReal
  | BillingsTaxiDriverContributionPenaltyDummy;

export default BillingsTaxiDriverContributionPenalty;
